import React, { PureComponent } from 'react'
import { ticketItemData, modalActionComments, clearTicketData } from "../../actions/index";
import { connect } from "react-redux";
import CommentModal from '../NewComment/Comment'
import Pagination from '../pagination'
import { URL_API } from "../../constants";
import { listStatus } from "../../actions/status";
import { listRepair, clearRepairModel } from "../../actions/repairModel";
import Loading from "../Loading"
import { fetchHistoryData, clearHistoryData } from '../../actions/history'
import { fetchCommentsData, clearCommentsData } from "../../actions/comments";
import { fetchDataRegion, regionClear } from "../../actions/region";
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import { privilege } from "../../privilege";
import Service from '../../containers/Service'
import Icon from '@material-ui/core/Icon'
import TrackNumber from '../TrackNumber/TrackNumber'
import { updateTicket } from '../../actions/ticketAction'
import Button from '@material-ui/core/Button';
import SwitchBox from '../FormComponent/SwitchBox'
import cs from 'classnames'

import { withStyles } from '@material-ui/core/styles'
import { modelTechnics, producerTechnics, typeTechnics } from "../../actions";
import Status from "../../containers/Status";
import CheckBox from '../FormComponent/CheckBox'

///
// repairs: [2]
// status: 7

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

class Detail extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      tab: 0,
    }
    this.access = (this.props.username === 'admin') ? privilege.group.Admin : privilege.group[this.props.group];
  }
  componentWillMount() {
    const id = this.props.match;
    this.props.fetchData(`${URL_API}/request/${id}/`);

  }
  componentDidMount() {
    const id = this.props.match;
    this.props.listStatus()
    this.props.typeTechnics()
    this.props.producerTechnics()
    this.props.modelTechnics()
    this.props.fetchCommentsData(`${URL_API}/comment/?request_id=${id}`)
    this.props.fetchHistoryData(`${URL_API}/history/?request_id=${id}`)
  }

  componentWillReceiveProps(nextProps) {
    const id = this.props.match;
    if (this.props.ticket.repair_id !== nextProps.ticket.repair_id || this.props.ticket.status_id !== nextProps.ticket.status_id) {
      this.props.fetchHistoryData(`${URL_API}/history/?request_id=${id}`)
    }
    if (this.props.addComment !== nextProps.addComment) {
      this.props.fetchCommentsData(`${URL_API}/comment/?request_id=${id}`)
    }
    if (this.props.ticket.dep !== nextProps.ticket.dep) {
      nextProps.fetchDataRegion(nextProps.ticket.dep.region);
    }


    if (this.props.ticket.equip !== nextProps.ticket.equip) {
      nextProps.listRepair(nextProps.ticket.equip.model)

    }

    if (this.props.ticket.nova_poshta_come !== nextProps.ticket.nova_poshta_come ||
      this.props.ticket.nova_poshta_leave !== nextProps.ticket.nova_poshta_come) {
    }

  }

  componentWillUnmount() {
    this.props.clearTicket()
    this.props.clearHistoryData()
    this.props.clearCommentsData()
    this.props.regionClear()
    this.props.clearRepairModel()
  }


  paginationActionHistory = (url) => {
    this.props.fetchHistoryData(`${url}`);
  }
  paginationActionComments = (url) => {
    this.props.fetchCommentsData(`${url}`);
  }

  modalIsOpen = () => {
    this.props.openModal(true);
  }

  handleChangeTab = (event, value) => {
    this.setState({
      tab: value
    });
  }

  renderModel = (id) => {
    const result = this.props.model.filter(item => item.id === id)
    if (result.length === 0) {
      return null
    }
    return result[0].name
  }
  renderProducer = (id) => {
    const result = this.props.producer.filter(item => item.id === id)
    if (result.length === 0) {
      return null
    }
    return result[0].name
  }
  renderType = (id) => {

    const result = this.props.techlist.filter(item => item.id === id)
    if (result.length === 0) {
      return null
    }
    return result[0].name
  }

  renderStatus = (id) => {
    const result = this.props.statusList.filter(item => item.id === id)
    if (result.length === 0) {
      return null
    }
    return result[0].name
  }
  renderRepair = (repairs) => {
    if (repairs.length) {
      return (
        <div>
          {repairs.map(repair => {
            return (<p key={repair.id}><i className="material-icons">done</i> {repair.name}</p>)
          })}
        </div>
      )
    }

  }

  handleImpossibleRepair = () => {
    const data = {
      repairs: [2],
      status: 7
    }
    const { updateTicket, match } = this.props
    updateTicket(match, data)
  }

  renderComments = () => {
    const id = this.props.match;
    const url_comment = `${URL_API}/comment/?request_id=${id}`
    if (this.props.comments.length !== 0) {
      return (
        <div className="ticket__comments-list">
          {this.props.comments.results.map((item, i) => {

            return (<div className="comments-item" key={i}>
              <div className="comments-item_title">
                <div className="comments__author">
                  Автор: {item.user}
                </div>
                <div className="comments__author">
                  Дата: {item.created_at}
                </div>
              </div>
              <div className="comments-item_text">
                {item.comment}
              </div>
            </div>)
          })}


          <Pagination count={this.props.comments.count}
            next={this.props.comments.next}
            previous={this.props.comments.previous}
            url={url_comment}
            action={this.paginationActionComments}
          />
        </div>
      )
    } else {
      return (
        <div className="container center">
          <Loading />
        </div>
      )
    }
  }


  renderHistory = () => {
    const id = this.props.match;
    const url_history = `${URL_API}/history/?request_id=${id}`
    if (this.props.history.length !== 0) {
      return (
        <div className="ticket__history-list">
          <ul className="collection">
            <li className="collection-item history__item">
              <div className="history__author">Користувач</div>
              <div className="history__date">Дата</div>
              <div className="history__action">Змінив статус на</div>
              <div className="history__action">Тип ремонту</div>
            </li>
            {this.props.history.results.map((item, i) => {
              return (
                <li className="collection-item history__item" key={i}>
                  <div className="history__author">{item.user}</div>
                  <div className="history__date">{item.created_at}</div>
                  <div className="history__action">{item.status}</div>
                  <div className="history__action">{this.renderRepair(item.repairs)}</div>
                </li>
              )
            })}

          </ul>

          <Pagination count={this.props.history.count}
            next={this.props.history.next}
            previous={this.props.history.previous}
            url={url_history}
            action={this.paginationActionHistory}
          />
        </div>
      )
    } else {
      return (
        <div className="container center">
          <Loading />
        </div>
      )
    }
  }

  render() {

    if (this.props.ticket.length === 0) {
      return (<main id="main" style={{ minHeight: '100vh' }}>
        <div className="container center">
          <Loading />
        </div>
      </main>)
    }

    const { ticket } = this.props;
    const { classes } = this.props;
    return (
      <main id="main">
        <Grid className="container">
          <Grid container>
            <Grid item xs={12} className={cs('ticket__title', classes.detailTitle)}>
              <h4> <Icon className="iconSmall" > assignment</Icon> Деталі заявки</h4>
              {this.access.status.read &&
                <Button variant="contained" color="secondary" onClick={this.handleImpossibleRepair}>
                  <Icon className="iconSmall"> report_problem</Icon> Ремонт неможливий</Button>}
            </Grid>
            <Grid container style={{ marginTop: '20px' }}>
              <Grid item xs={12} md={8} >
                <div className="ticket__info-group_item">
                  <span> Дата створення:</span>
                  <span>{ticket.created_at}</span>
                </div>
                <div className="ticket__info-group_item">
                  <span> Створив:</span>
                  <span>{ticket.user}</span>
                </div>
                <div className="ticket__info-group_item">
                  <span>Серійний номер:</span>
                  <span>{ticket.equip.series}</span>
                </div>

                <div className="ticket__info-group_item">
                  <span>Тип:</span>
                  <span>{this.renderType(ticket.equip.type)}</span>
                </div>


                <div className="ticket__info-group_item">
                  <span>Виробник:</span>
                  <span>{this.renderProducer(ticket.equip.producer)}</span>
                </div>


                <div className="ticket__info-group_item">
                  <span>Модель:</span>
                  <span>{this.renderModel(ticket.equip.model)}</span>
                </div>

                <div className="ticket__info-group_item">
                  <span style={{
                    alignItems: 'center',
                    verticalAlign: 'middle',
                    display: 'inline-flex'
                  }}>Гарантійний ремонт: </span>
                  <span>
                    <SwitchBox field={'is_warranty'}
                      id={ticket.id}
                      onChange={this.props.updateTicket}
                      value={ticket.is_warranty}
                      access={this.access}
                    />
                  </span>
                </div>
                <div className="ticket__info-group_item">
                  <span className="technics_item-title">Тип ремонту: </span>
                  <span>{this.renderRepair(ticket.repairs)}</span>
                </div>

                <TrackNumber
                  number={ticket.nova_poshta_come}
                  title={'Трек номер отримання'}
                  onSubmit={this.props.updateTicket}
                  id={ticket.id}
                  field={'nova_poshta_come'}
                  access={this.access}
                />
                <div className="ticket__info-group_item">
                  <span className="technics_item-title">Дата відправки: </span>
                  <span>{ticket.date_return_to_dep ? ticket.date_return_to_dep : ''}</span>
                </div>
                <TrackNumber
                  number={ticket.nova_poshta_leave}
                  title={'Трек номер відправки'}
                  id={ticket.id}
                  onSubmit={this.props.updateTicket}
                  field={'nova_poshta_leave'}
                  access={this.access}
                />
                <div className="ticket__info-group_item">
                  <span style={{ display: 'flex', alignItems: 'center' }}>Акт отриманно:</span>
                  <span>
                    <CheckBox
                      id={ticket.id}
                      is_document={ticket.is_document}
                    />
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} md={4}>
                {(this.access.status.read) ?
                  <Grid container>
                    <Grid item xs={12}>
                      {(this.access.status.edit) ? <div className="ticket__title">
                        Service Desk
                                                </div> : ''}
                      <div className="ticket__content">
                        <Status list={this.props.statusList}
                          access={this.access}
                          repair_list={this.props.repairModels}
                          status_id={ticket.status_id}
                          ticket_id={ticket.id} />
                      </div>
                    </Grid>
                  </Grid>
                  : ''}
                {(this.access.repair.read) ?
                  <Grid container>
                    <Grid item xs={12}>
                      {(this.access.repair.edit) ? <div className="ticket__title">
                        Сервісний центр
                                                </div> : ''}
                      <div className="ticket__content">
                        <Service list={this.props.statusList}
                          repair_list={this.props.repairModels}
                          access={this.access}
                          status_id={ticket.status_id}
                          ticket_id={ticket.id} />
                      </div>
                    </Grid>
                  </Grid>
                  : ''}
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12}>
                <div className="ticket__title">
                  Департамент
                        </div>
                <div className="ticket__content">
                  <div className="ticket__info-region">{this.props.region.name}</div>
                  <div className="ticket__info-departament">
                    {ticket.dep.code}  - {ticket.dep.name}
                  </div>
                </div>
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12} className="ticket__text">
                <div className="ticket__title">
                  Опис проблеми
                        </div>
                <div className="ticket__content">
                  {(ticket.description.length !== 0) ? ticket.description : ' '}
                </div>
              </Grid>
            </Grid>
          </Grid>

          <div className={classes.root}>
            <AppBar position="static" color="default">
              <Tabs value={this.state.tab} onChange={this.handleChangeTab} indicatorColor="primary">
                <Tab label="Коментарі" />
                <Tab label="Історія" />
              </Tabs>
            </AppBar>
            {this.state.tab === 0 && <TabContainer>
              <div className="ticket__comments">
                <div className="ticket__tab-header">
                  <span className="ticket__tab-title">Коментарі до зявки</span>
                  <Button variant="contained" color="primary" onClick={this.modalIsOpen}>Залишити коментар</Button>
                </div>
                <div className="ticket__content">
                  {this.renderComments()}
                </div>
              </div>


            </TabContainer>}
            {this.state.tab === 1 && <TabContainer>

              <div className="ticket__history">
                <div className="ticket__tab-header">
                  <span className="ticket__tab-title">Історія змін</span>
                </div>
                <div className="ticket__content">
                  {this.renderHistory()}
                </div>

              </div>
            </TabContainer>}
          </div>
        </Grid>
        <CommentModal user_id={this.props.auth.access.user_id} request_id={this.props.ticket.id} />
      </main>
    )
  }
}


const mapStateToProps = (state) => {
  return {
    ticket: state.ticket,
    open: state.commentModal,
    techlist: state.techlist,
    username: state.auth.username,
    model: state.modelList,
    group: state.auth.groups['0'],
    producer: state.producerList,
    auth: state.auth,
    repairList: state.listRepair,
    repairModels: state.repairModels.repair_type,
    statusList: state.listStatus,
    history: state.history,
    comments: state.comments,
    region: state.region,
    addComment: state.addComment,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchData: (url) => dispatch(ticketItemData(url)),
    openModal: (bool) => dispatch(modalActionComments(bool)),
    updateTicket: (id, jData) => dispatch(updateTicket(id, jData)),
    typeTechnics: () => dispatch(typeTechnics()),
    modelTechnics: () => dispatch(modelTechnics()),
    producerTechnics: () => dispatch(producerTechnics()),
    listStatus: () => dispatch(listStatus()),
    listRepair: (id) => dispatch(listRepair(id)),
    clearTicket: () => dispatch(clearTicketData()),
    fetchHistoryData: (url) => dispatch(fetchHistoryData(url)),
    clearHistoryData: () => dispatch(clearHistoryData()),
    fetchCommentsData: (url) => dispatch(fetchCommentsData(url)),
    clearCommentsData: () => dispatch(clearCommentsData()),
    clearRepairModel: () => dispatch(clearRepairModel()),
    fetchDataRegion: (id) => dispatch(fetchDataRegion(id)),
    regionClear: () => dispatch(regionClear()),
  };
};

const styles = theme => ({

  root: {
    flexGrow: 1,
    marginTop: theme.spacing.unit * 3,
    backgroundColor: theme.palette.background.paper,
  },
  button: {
    margin: theme.spacing.unit,
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  rightIcon: {
    marginLeft: theme.spacing.unit,
  },
  iconSmall: {
    fontSize: 20,
  },
  detailTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Detail))


// WEBPACK FOOTER //
// ./src/components/Detail/Detail.js